import React, { Fragment, Component }           		from 'react';
import { BrowserRouter, Route, Switch, Redirect }  		from 'react-router-dom';

// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import react-spinner-loader css
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
// Import Main styles for this application
import './scss/style.css';
import './scss/preloader.css';

import { DefaultLayout } from './containers';
import { Login, Page404, Page500, Register, Email, Password } from './views';

import checkout from './views/checkout.js';
import Confirmation from './views/Register/Confirmation.jsx';
import Confirmed from './views/Register/Confirmed.jsx';
import ConfirmedClient from './views/Register/ConfirmedClient.jsx';
import InvalidateEmail from './views/Register/InvalidateEmail.jsx';

import { getCompany } from './store/actions/initialState';
import { scheduleTokenRenewal } from './store/actions/userActions';
import { connect } from 'react-redux';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';

import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-85340412-2');
ReactGA.pageview(window.location.pathname + window.location.search);





const PrivateRoute = ({ component: Component, ...rest }) => (
  	<Route { ...rest } render={ (props) => localStorage.getItem('user') ? <Component {...props} /> : (<Redirect to={{ pathname: '/login', state: { from: props.location }}}/>
	)}
  />
);

export const BranchRequiredRoute = connect(({ branch }) => ({
	branch
}))(({ component: Component, ...rest }) => {
	return (
		<Route { ...rest } render={ (props) => {
			let user = localStorage.getItem('user')

			if (user) {
				if (rest.branch && Object.keys(rest.branch).length > 0) {
					return <Component {...props} />
				}

				return (
					<h2 className="d-flex justify-content-center align-items-center flex-grow-1 text-center mt-4">
						Selecciona un comercio
					</h2>
				)
			}

			return <Redirect to={{ pathname: '/login', state: { from: props.location }}}/>

		}} />
	)
})


class App extends Component {
	constructor(props) {
    	super(props);
		props.getCompany();
		this.state = {
			defaultNotiPosition: localStorage.getItem("notiPosition") || "BOTTOM_RIGHT"
		  };

		if(localStorage.getItem('user'))
    		scheduleTokenRenewal();
	}

	componentDidMount() {
		// const hostname = window.location.hostname;

		// switch (hostname) {
		// 	case 'panel-dev.dondemand.io':
		// 		window.location.href = window.location.href.replace(hostname, 'zupper-panel-beta.ridery.app');
		// 		return;
		// 	case 'panel-staging.dondemand.io':
		// 		window.location.href = window.location.href.replace(hostname, 'zupper-panel-staging.zupper.io');
		// 		return;
		// 	case 'zupper-panel.dondemand.io':
		// 		window.location.href = window.location.href.replace(hostname, 'panel.zupper.io');
		// 		return;
		// }

		window.addEventListener('notificationPositionChange', this.handlePositionChange);
	}

	componentWillUnmount() {
		window.removeEventListener('notificationPositionChange', this.handlePositionChange);
	}

	handlePositionChange = (event) => {
		this.setState({ defaultNotiPosition: event.detail.position });
	};


	componentDidUpdate(prevProps){
		if(prevProps && prevProps.color_accent !== this.props.color_accent){
			document.documentElement.style.setProperty('--primary', this.props.color_accent);
			document.documentElement.style.setProperty('--info', this.props.color_accent);
		}
		if(this.props.isZupper){
			document.documentElement.style.setProperty('--light','#2f353a');
			document.documentElement.style.setProperty('--dark', '#f0f3f5');
		}else{
			document.documentElement.style.setProperty('--light','#FFF');
		}
	}

	render() {

		if(this.props.company.id === '')
		{
			return (
				<div className='page-loader'>
				<div className='preloader pls-white'>
					<svg className='pl-circular' viewBox='25 25 50 50'>
						<circle className='plc-path' cx={50} cy={50} r={20} />
					</svg>
					<p>{ this.props.json_lang.common.waiting_message}</p>
				</div>
			</div>
		);
		}
		else {

			return <Fragment>
			{/*
				this.props.company.name ?
					<Helmet>
						<title> Dondemand | {this.props.company.name} - Admin</title>
						<meta name="description" content={METADESCRIPTION}/>
						<meta name="author" content={METAAUTOR}/>
						<meta name="keyword" content={METAKEYWORD}/>
					</Helmet>
				: null
			*/}
			<ToastContainer
				position={ toast.POSITION[this.state.defaultNotiPosition] }
						transition={ Slide }
				toastClassName={ 'noti_container' }
						autoClose={ 3500 }
				limit= {2}
						hideProgressBar={ true }
				newestOnTop={ false }
				draggable={ true }
			/>
			<BrowserRouter>
				<Switch>
					<Route exact path='/login' name='Login Page' component={ Login } />
					<Route exact path='/register' name='Register Page' component={ Register } />
					<Route exact path='/confirmation/:id/:token' name='Confirmation User Register' component={ Confirmation } />
					<Route exact path='/confirmed' name='Usuario confirmado' component={ Confirmed } />
					<Route exact path='/confirmed-client' name='Usuario confirmado' component={ ConfirmedClient } />
					<Route exact path='/invalidate/:id/:token' name='Confirmation User Register' component={ InvalidateEmail } />
					<Route exact path='/password-reset' name='Reset Password' component={ Email } />
					<Route exact path='/recover/:id/:token' name='Reset Password' component={ Password } />
					<Route exact path='/checkout/:id' name='Checkout' component={ checkout } />
					<Route exact path='/404' name='Page 404' component={ Page404 } />
					<Route exact path='/500' name='Page 500' component={ Page500 } />
					<PrivateRoute path='/' component={ DefaultLayout } />
				</Switch>
			</BrowserRouter>
		</Fragment>
		}

	}
}

const mapStateToProps = (state) => {
	let zupper = false;
	if(state.company){
		if(state.company.id === 7  || state.company.id === 120){
			zupper = true
		}
	}
	return {
		errors: state.errors,
	 	session: state.session,
		company: state.company,
		json_lang: state.json_lang,
		color_accent:state.company_styles_json && state.company_styles_json.color_accent,
		isZupper:zupper
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getCompany: () => dispatch(getCompany())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js